__turbopack_context__.v({
  "banner": "CategoryBanner-module-scss-module__Ej8qIq__banner",
  "banner--center": "CategoryBanner-module-scss-module__Ej8qIq__banner--center",
  "banner--start": "CategoryBanner-module-scss-module__Ej8qIq__banner--start",
  "banner__copy": "CategoryBanner-module-scss-module__Ej8qIq__banner__copy",
  "banner__description": "CategoryBanner-module-scss-module__Ej8qIq__banner__description",
  "banner__eyebrow": "CategoryBanner-module-scss-module__Ej8qIq__banner__eyebrow",
  "banner__headline": "CategoryBanner-module-scss-module__Ej8qIq__banner__headline",
  "banner__image": "CategoryBanner-module-scss-module__Ej8qIq__banner__image",
  "banner__inner": "CategoryBanner-module-scss-module__Ej8qIq__banner__inner",
});
